import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import _ from "lodash";
import GobLogo from './assets/images/gobmxlogo.svg';
import INMLogo from './assets/images/logo_inm.svg';
import LoginBox from "./elements/login/login";
import WelcomeBox from "./elements/login/welcome";
import {login, recover, userReset, validateSession} from './actions/login';
import Loading from "./elements/loading";

class LoginLayout extends Component {
	render () {
		let {menu, profile} = this.props.userLogin.data;
		let {checked, authenticated} = this.props.session;
		let {register} = this.props;
		return ((checked && authenticated) ? <Loading /> :
			<section className="hero is-fullheight is-black login-layout">
				<div className="hero-head">
					<header className="nav" style={{backgroundColor:'#393c3e'}}>
						<div className="container">
							<div className="nav-left">
								<a className="nav-item">
									<img src={GobLogo} alt="Logo"/>
								</a>
							</div>
						</div>
					</header>
				</div>

				<div className="hero-body">
					<div className="container">
						<div className="columns is-centered is-gapless">
							<div className="column is-one-third">
								<div className="columns is-gapless">
									<div className="column">
										<img src={INMLogo} alt="Instituto Nacional de la Mujer" className="logo-inm" />
									</div>
								</div>
								{!_.isEmpty(menu) ?
									<WelcomeBox userLogin={profile} /> :
									<LoginBox action={this.state.action} setActionType={this._setActionType} query={this.props.location.search} userRecover={this.props.userRecover} userReset={this.props.userReset} login={this.props.login} userLogin={this.props.userLogin} register={register}/>}
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}

	constructor() {
		super();
		this.state = {
			action: 'login'
		}
		this._setActionType = this._setActionType.bind(this);
	}

	_setActionType = (action) => {
		return this.setState({action});
	}

	componentWillMount() {
		if(this.props.location.pathname === '/' && this.props.location.search.indexOf('reset') !== -1){
			this._setActionType('reset');
			//query = this.props.location.search
		}else{
			this.props.validateSession();
		}
	}

};

const mapStateToProps = (state) => {
	const { userLogin, session, register } = state;
	return {userLogin, session, register};
}

const mapDispatchToProps = dispatch => {
	return {
		validateSession: () => {
			return dispatch(validateSession())
		},
		login: (values) => {
			return dispatch(login(values))
		},
		userRecover: (email) => {
			return dispatch(recover(email))
		},
		userReset: (values, query) => {
			return dispatch(userReset(values, query))
		}
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginLayout));



// WEBPACK FOOTER //
// ./src/loginapp.js